import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { HistorySearch, LinkStats } from 'src/app/models/buddy';
import { BuddyService } from 'src/app/services/buddy.service';

@Component({
  selector: 'app-mobile-history',
  templateUrl: './mobile-history.component.html',
  styleUrls: ['./mobile-history.component.css']
})
export class MobileHistoryComponent implements OnInit {

  constructor(
    private spinner: NgxSpinnerService,
    private buddyService: BuddyService
  ) { }

  ngOnInit(): void {
    this.getLinkStatsHistoryList()
  }
  list: LinkStats[]
  getLinkStatsHistoryList() {
    this.spinner.show();
    let search = new HistorySearch()
    search.refererGroup = ''
    search.fromDate = moment(new Date()).add(1, 'day').add(-1, 'M')
    search.toDate = moment(new Date())
    search.searchDateType = 'eventDate'
    search.searchType = 'title'
    this.buddyService.getLinkStatsHistoryList(search).subscribe(res => {
      this.spinner.hide()
      this.list = res.data.content
    })
  }
}
